import dayjs from 'dayjs';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const DATE_TIME_LONG_FORMAT = 'YYYY-MM-DDTHH:mm';

// Vue 3 : plus de `Vue.filter`. Ces helpers sont exposés globalement via app.config.globalProperties
// dans main.ts, et remplacent les anciens filtres `| formatDate` / `| duration` (à corriger dans les templates).
export function formatDate(value: any): string {
  if (value) {
    return dayjs(value).format(DATE_TIME_FORMAT);
  }
  return '';
}

export function duration(value: any): string {
  if (value) {
    const formatted = dayjs.duration(value).humanize();
    if (formatted) {
      return formatted;
    }
    return value;
  }
  return '';
}
